const navbarInit = () => {
  const header: Element = document.querySelector('.navigation-main');
  const logo: Element = header.querySelector('.navigation-main__logo');
  const mobileMenu: Element = header.querySelector(
    '.navigation-main__mobile-menu',
  );
  const mainWrapper: Element = header.querySelector(
    '.navigation-main__wrapper',
  );
  const sideNav: Element = header.querySelector('.navigation-main__side');
  const toggler: Element = header.querySelector('.navigation-toggler');
  const togglerActive: string = 'active';
  const headerElement: Element = document.querySelector('.header');
  const bottomNavToggler: Element = document.querySelector(
    '.navigation-main__mobile-menu-bottom-toggle',
  );
  const bottomNav: Element = document.querySelector('.navigation-bottom');
  const bottomNavClose: Element = document.querySelector(
    '.navigation-bottom__mobile-back',
  );
  const topNavToggler: Element = document.querySelector(
    '.navigation-main__mobile-menu-top-toggle',
  );
  const topNav: Element = document.querySelector('.navigation-top');
  const topNavClose: Element = document.querySelector(
    '.navigation-top__mobile-back',
  );

  if (toggler) {
    toggler.addEventListener('click', (e: Event) => {
      e.stopPropagation();
      toggler.classList.toggle(togglerActive);
      mobileMenu.classList.toggle(togglerActive);
      headerElement.classList.toggle(togglerActive);
      logo.classList.toggle(togglerActive);
      mainWrapper.classList.toggle(togglerActive);
      sideNav.classList.toggle(togglerActive);
    });
  }

  if (bottomNavToggler) {
    bottomNavToggler.addEventListener('click', (e) => {
      e.preventDefault();
      bottomNav.classList.toggle('active');
    });
  }

  if (bottomNavClose) {
    bottomNavClose.addEventListener('click', (e) => {
      e.preventDefault();
      bottomNav.classList.toggle('active');
    });
  }

  if (topNavToggler) {
    topNavToggler.addEventListener('click', (e) => {
      e.preventDefault();
      topNav.classList.toggle('active');
    });
  }

  if (topNavClose) {
    topNavClose.addEventListener('click', (e) => {
      e.preventDefault();
      topNav.classList.toggle('active');
    });
  }
};

export default navbarInit;
